"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AddonItem;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _content = require("@sart/content");
var _utilities = require("@sart/utilities");
var _icons = require("@sart/icons");
var _Text = _interopRequireDefault(require("./Text"));
var _Price = _interopRequireDefault(require("./Price"));
var _Space = _interopRequireDefault(require("./Space"));
var _excluded = ["product", "disabled", "onPress", "style", "iconStyle", "bodyStyle", "headerStyle", "titleStyle", "priceStyle", "descriptionStyle", "basket", "allowDelete", "removeProductFunction", "durationStyle", "iconColor", "removable"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function typeOfProduct(_ref) {
  var localData = _ref.localData,
    localMinutes = _ref.localMinutes,
    localSMS = _ref.localSMS;
  if (localData > 0 && !localMinutes && !localSMS) {
    return 'data';
  }
  if (localMinutes > 0 && !localData && !localSMS) {
    return 'minutes';
  }
  if (localSMS > 0 && !localData && !localMinutes) {
    return 'sms';
  }
  return 'hybrid';
}
function AddonItem(props) {
  var product = props.product,
    disabled = props.disabled,
    onPress = props.onPress,
    style = props.style,
    iconStyle = props.iconStyle,
    bodyStyle = props.bodyStyle,
    headerStyle = props.headerStyle,
    titleStyle = props.titleStyle,
    priceStyle = props.priceStyle,
    descriptionStyle = props.descriptionStyle,
    basket = props.basket,
    allowDelete = props.allowDelete,
    removeProductFunction = props.removeProductFunction,
    durationStyle = props.durationStyle,
    iconColor = props.iconColor,
    removable = props.removable,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var content = (0, _content.useContent)();
  var type = typeOfProduct(product);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.container, style],
    onPress: onPress,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.icon, iconStyle]
  }, /*#__PURE__*/_react["default"].createElement(_icons.AddonIcon, {
    size: 24,
    iconColor: iconColor
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [product.productName.length > 20 || product.description.length > 20 ? styles.bodyLong : styles.body, bodyStyle]
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.title, titleStyle]
  }, product.productName), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.description, descriptionStyle]
  }, product.description)), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.second
  }, /*#__PURE__*/_react["default"].createElement(_Price["default"], {
    value: product.upfrontCost > 0 ? product.upfrontCost : product.recurringCost,
    style: [styles.title, priceStyle],
    code: product.currency
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: durationStyle
  }, content.common["for"].toUpperCase(), " ", product.validity, " ", product.validityUnit)), /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, (0, _extends2["default"])({
    style: styles.add,
    onPress: onPress
  }, (0, _utilities.testID)(product.id + 'Button')), !removable && /*#__PURE__*/_react["default"].createElement(_icons.Plus, {
    size: 12,
    color: iconColor
  }), removable && /*#__PURE__*/_react["default"].createElement(_icons.Minus, {
    size: 12,
    color: iconColor
  })));
}
AddonItem.propTypes = {
  product: _propTypes["default"].object
  // onPress: PropTypes.func
};
var styles = _reactNative.StyleSheet.create({
  container: {
    flexDirection: 'row',
    overflow: 'hidden',
    height: 80
  },
  icon: {
    // flex: 1,
    width: 50,
    alignItems: 'center',
    justifyContent: 'center'
    // alignContent: 'flex-end'
    // backgroundColor: 'red'
  },
  add: {
    // flex: 1,
    width: 50,
    // alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-end',
    paddingRight: 10
  },
  body: {
    paddingTop: 12,
    paddingBottom: 12,
    minWidth: '50%',
    justifyContent: 'center'
    // backgroundColor: 'blue'
  },
  second: {
    // backgroundColor: 'blue',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    width: '30%',
    justifyContent: 'center',
    paddingLeft: 10
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: _objectSpread({
    lineHeight: 14,
    fontSize: 14
  }, _styles.typography.extraBold),
  bodyLong: {
    paddingTop: 12,
    paddingBottom: 12,
    width: '50%',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
  },
  description: {
    fontSize: 14,
    lineHeight: 14
  },
  itemSubHeaderItemStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
});